export default class DaisyBaseService {
    constructor($injector) {
        this.$http = $injector.get('$http');
        this.$log = $injector.get('$log');
        this.Flash = $injector.get('Flash');
        this.$q = $injector.get('$q');

        // this.baseUrl = 'http://213.144.0.222:80/dntapi/';
        // this.baseUrl = 'http://PEI2KGWEDAISY3:80/dntapi/';
        // this.baseUrl = 'http://hpo-me03:80/dntapi/';
        this.baseUrl = 'http://PEI2KGWEDAISY3:80/dntapi/';
        this.eventName = 'GWE55V3V';

        this.statusEnum = {
            OK: 'MSCOK',
            INFO: 'MSCInformation'
        }
    }

    doResponseHandling(response){
        if (response.status == 200){
            let responseArray = response.data.result;
            if (0 in responseArray){
                let responseCode = responseArray[0];
                if (responseCode.CODE == this.statusEnum.OK){
                    if(1 in responseArray){
                        return responseArray[1];
                    }
                    return;
                }
                else if(responseCode.CODE == this.statusEnum.INFO){
                    if(1 in responseArray){
                        this.Flash.create('info', responseCode.MESSAGE);
                        return responseArray[1];
                    }
                }
                else{
                    this.Flash.create('danger', responseCode.MESSAGE);
                    return this.$q.reject(new Error(responseCode));
                }
            }
        }
        this.Flash.create('danger', 'Ein unvorhergesehener Fehler ist aufgetreten');
    }

    doPost(functionUrl, data){
        return this.$http.post(this.baseUrl + functionUrl, data).then(
            (result) => {
                return this.doResponseHandling(result);
            },
            (reason) => {
                this.Flash.create('danger', 'Ein unvorhergesehener Fehler ist aufgetreten');
                return this.$q.reject(new Error(reason));
            }
        );
    }
}